import { useState, useEffect } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'

export const useReportTypes = () => {
  const [reportTypes, setReportTypes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchReportTypes() {
      setLoading(true)
      setError(null)

      try {
        const { data, error: fetchError } = await supabaseGetter.reportTypes.getAll()
        if (fetchError) throw fetchError
        setReportTypes(data || [])
      } catch (err) {
        console.error('Error fetching report types:', err)
        setError(err.message)
        setReportTypes([])
      } finally {
        setLoading(false)
      }
    }

    fetchReportTypes()
  }, [])

  return { reportTypes, loading, error }
}
